var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon/link"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M10 13C10.4295 13.5741 10.9774 14.0492 11.6066 14.3929C12.2357 14.7367 12.9315 14.9411 13.6467 14.9923C14.3618 15.0436 15.0796 14.9404 15.7513 14.6898C16.4231 14.4392 17.0331 14.0471 17.54 13.54L20.54 10.54C21.4508 9.59699 21.9548 8.33398 21.9434 7.02299C21.932 5.71201 21.4061 4.45795 20.4791 3.53091C19.5521 2.60387 18.298 2.07802 16.987 2.06663C15.676 2.05524 14.413 2.55921 13.47 3.47L11.75 5.18",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#E6E9EB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M14 11C13.5705 10.4259 13.0226 9.95082 12.3934 9.60706C11.7643 9.2633 11.0685 9.05888 10.3533 9.00767C9.63821 8.95645 8.92041 9.05963 8.24865 9.31022C7.5769 9.5608 6.96689 9.95293 6.46 10.46L3.46 13.46C2.54921 14.403 2.04524 15.666 2.05663 16.977C2.06802 18.288 2.59387 19.5421 3.52091 20.4691C4.44795 21.3961 5.70201 21.922 7.01299 21.9334C8.32398 21.9448 9.58699 21.4408 10.53 20.53L12.24 18.82",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#E6E9EB"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLink);
export default __webpack_public_path__ + "static/media/icon_link.38e9cfc3d79b80237b5c4d222222f01d.svg";
export { ForwardRef as ReactComponent };